import { clsx } from 'clsx';
import { forwardRef } from 'react';

import styles from './MapLayout.css';

type MapLayoutProps = {
  map: React.ReactNode;
  banners: React.ReactNode;
  disabled?: boolean;
};

export const MapLayout = forwardRef<HTMLDivElement, MapLayoutProps>(function MapLayout(
  { map, banners, disabled },
  ref,
) {
  return (
    <div className={clsx(styles['map-layout'], disabled && styles['map-layout--disabled'])} ref={ref}>
      {map}
      {banners}
    </div>
  );
});
